import { render } from "./Pentadbir.vue?vue&type=template&id=3c54ce14"
import script from "./Pentadbir.vue?vue&type=script&lang=js"
export * from "./Pentadbir.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__